import './Account.scss';

import React from 'react';
import { connect } from "react-redux";
import { routerActions } from "react-router-redux";
import classNames from 'classnames';
import { Elements, StripeProvider } from "react-stripe-elements";

import { setAuthError, setCredentials } from 'containers/Auth/store/actions';
import { postPutCompany, postPutUser, setCompany, setUser } from 'containers/Accounts/store/actions';
import { getAllIndustryExperienceTypes, getAllLocations, getAllSkills, getAllSpecialties } from 'containers/App/store/actions';
import { uploadProfileImage } from 'containers/Accounts/store/actions';

import A from 'components/A/index';
import AgencyAccountForm from './AgencyAccountForm';
import AgencyBillingForm from './AgencyBillingForm';
import Button from 'components/Button/index';
import FreelancerAccountForm from './FreelancerAccountForm';
import H1 from 'components/H1/index';
import Modal from 'components/Modal/index';
import Nav from 'components/Nav/index';
import NavItem from 'components/NavItem/index';
import NotificationsForm from 'containers/Accounts/Edit/NotificationsForm';
import PageContent from 'components/PageContent/index';
import SecurityForm from 'containers/Accounts/Edit/SecurityForm';

class Account extends React.Component {
    constructor() {
        super();

        this.tabs = ['profile', 'business', 'billing', 'notifications', 'security'];

        this.state = {
            adminView: false,
            showSuccessModal: false
        };
    }

    componentWillMount() {
        document.body.classList.add('account-page');

        this.props.getAllIndustryExperienceTypes();
        this.props.getAllLocations();
        this.props.getAllSkills();
        this.props.getAllSpecialties();

        if(['/business/new', '/user/new'].indexOf(window.location.pathname) !== -1) {
            if(this.props.auth.user.isAdmin === false) {
                this.props.changeLocation('/account/profile');
            }
            this.setState({adminView: true});
        } else {
            if(this.tabs.indexOf(this.props.params.tab) === -1) {
                this.props.changeLocation('/account/profile');
            }

            if(this.props.params.tab === 'business' && this.props.auth.user.company == null) {
                this.props.changeLocation('/account/profile');
            }

            this._setDataInAccounts();
        }
    }

    componentWillUnmount() {
        document.body.classList.remove('account-page');
    }

    componentWillReceiveProps(nextProps) {
        // Route changed (tab changed) so need to reset user object
        if(this.props.routing.locationBeforeTransitions.pathname !== nextProps.routing.locationBeforeTransitions.pathname) {
            if(['/business/new', '/user/new'].indexOf(nextProps.routing.locationBeforeTransitions.pathname) !== -1) {
                if(this.props.auth.user.isAdmin === false) {
                    this.props.changeLocation('/account/profile');
                }
                this.setState({adminView: true});
            } else {
                this.setState({adminView: false});
                this._setDataInAccounts();
            }
        }
    }

    handleCompanySubmit(isValid) {
        if(isValid === true) {
            this.props.postPutCompany()
                .then((res) => {
                    //TODO: Show different modals for saving company or password
                    this.setState({
                        showSuccessModal: true
                    });
                });
        } else {
            this.props.setAuthError('error', 'There was an error in your form. Please correct and resubmit.')
        }
    }

    handleUserSubmit(isValid, navigateToPreview) {
        if(isValid === true) {
            this.props.postPutUser()
                .then((res) => {
                    //TODO: Show different modals for saving company or password
                    if(navigateToPreview) {
                        this.props.changeLocation('/freelancer/preview');
                    } else {
                        this.setState({
                            showSuccessModal: true
                        });
                    }
                });
        } else {
            this.props.setAuthError('error', 'There was an error in your form. Please correct and resubmit.')
        }
    }

    _setDataInAccounts() {
        if(this.props.params.id == null) {
            this.props.setUser(this.props.auth.user);
            this.props.setCompany(this.props.auth.user.company);
        } else {
            //TODO: Handle editing users by admin using this.props.getUserById()
        }
    }

    uploadAgencyAvatar() {
        this.props.uploadProfileImage('agency');
    }

    uploadUserAvatar() {
        this.props.uploadProfileImage('user');
    }

    render() {
        let urlTab = this.props.params.tab;

        return (
            <PageContent className="account">
                <H1>
                    {this.state.adminView !== true ? 'Account' : `Create New ${window.location.pathname === '/user/new' ? 'User' : 'Member'}`}
                </H1>

                {this.state.adminView !== true ? (
                    <Nav className="account__nav">
                        <ul className="c-nav__menu account__menu">
                            {this.tabs.map((tab, index) => {
                                if(this.props.auth.user.isFreelancer && (index === 1 || index === 2)) {
                                    return null;
                                } else {
                                    return (
                                        <NavItem key={index}>
                                            <A className={classNames('account__tab', {'a-nav-item__link--active': tab === urlTab})}
                                               onClick={() => {
                                                   this.props.setAuthError('error', null);
                                                   this.setState({showSuccessModal: false});
                                               }}
                                               to={`/account/${tab}`}>
                                                {tab}
                                            </A>
                                        </NavItem>
                                    );
                                }
                            })}
                        </ul>
                    </Nav>
                ) : null}

                {urlTab === 'profile' || (this.state.adminView === true && window.location.pathname === '/user/new') ? (
                    <FreelancerAccountForm
                        adminView={this.state.adminView}
                        avatarError={this.props.accounts.error}
                        error={this.props.accounts.error}
                        industryExperienceTypes={this.props.app.industryExperienceTypes}
                        isSaving={this.props.accounts.isSavingUser}
                        isSavingAvatar={this.props.accounts.isSavingAvatar}
                        locations={this.props.app.locations}
                        onInvalid={this.handleUserSubmit.bind(this, false)}
                        onValid={(navigateToPreview) => this.handleUserSubmit(true, navigateToPreview)}
                        setUser={this.props.setUser.bind(this)}
                        showChangeNotification={this.state.showUserAvatarChangeNotification}
                        skills={this.props.app.skills}
                        specialties={this.props.app.specialties}
                        uploadAvatar={this.uploadUserAvatar.bind(this)}
                        user={this.props.accounts.user}
                    />
                ) : null}

                {urlTab === 'business' || (this.state.adminView === true && window.location.pathname === '/business/new') ? (
                    <AgencyAccountForm
                        adminView={this.state.adminView}
                        avatarError={this.props.accounts.error}
                        company={this.props.accounts.company}
                        error={this.props.accounts.error}
                        isSaving={this.props.accounts.isSavingCompany}
                        isSavingAvatar={this.props.accounts.isSavingAvatar}
                        locations={this.props.app.locations}
                        onInvalid={this.handleCompanySubmit.bind(this, false)}
                        onValid={this.handleCompanySubmit.bind(this, true)}
                        setCompany={this.props.setCompany.bind(this)}
                        showChangeNotification={this.state.showAgencyAvatarChangeNotification}
                        skills={this.props.app.skills}
                        specialties={this.props.app.specialties}
                        uploadAvatar={this.uploadAgencyAvatar.bind(this)}
                        user={this.props.accounts.user}
                    />
                ) : null}

                {urlTab === 'billing' ? (
                    <StripeProvider apiKey={process.env.REACT_APP_STRIPE_API_KEY}>
                        <Elements>
                            <AgencyBillingForm />
                        </Elements>
                    </StripeProvider>
                ) : null}

                {urlTab === 'notifications' ? (
                    <NotificationsForm
                        error={this.props.accounts.error}
                        isSaving={this.props.accounts.isSavingUser}
                        onInvalid={this.handleUserSubmit.bind(this, false)}
                        onValid={this.handleUserSubmit.bind(this, true)}
                        setUser={this.props.setUser.bind(this)}
                        user={this.props.accounts.user}
                    />
                ) : null}

                {urlTab === 'security' ? (
                    <SecurityForm
                        credentials={this.props.auth.credentials}
                        error={this.props.accounts.error}
                        isSaving={this.props.accounts.isSavingUser}
                        onInvalid={this.handleUserSubmit.bind(this, false)}
                        onValid={this.handleUserSubmit.bind(this, true)}
                        setCredentials={this.props.setCredentials.bind(this)}
                        setUser={this.props.setUser.bind(this)}
                        user={this.props.accounts.user}
                    />
                ) : null}

                <Modal show={this.state.showSuccessModal === true}
                       title="Success!">
                    {this.state.adminView === true ? (
                        <p>
                            {window.location.pathname === '/user/new' ? 'This user account has been created.' : 'This business has been created.'}
                        </p>
                    ) : (
                        <p>
                            Your account profile has been updated.
                        </p>
                    )}
                    <div className="c-modal__button-wrapper">
                        <Button onClick={() => this.setState({showSuccessModal: false})}>
                            OK
                        </Button>
                    </div>
                </Modal>
            </PageContent>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        accounts: state.accounts,
        app: state.app,
        auth: state.auth,
        routing: state.routing
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        changeLocation: (path) => dispatch(routerActions.push(path)),
        getAllIndustryExperienceTypes: () => dispatch(getAllIndustryExperienceTypes()),
        getAllLocations: () => dispatch(getAllLocations()),
        getAllSkills: () => dispatch(getAllSkills()),
        getAllSpecialties: () => dispatch(getAllSpecialties()),
        postPutCompany: () => dispatch(postPutCompany()),
        postPutUser: () => dispatch(postPutUser()),
        setAuthError: (name, error) => dispatch(setAuthError(name, error)),
        setCompany: (companyObj) => dispatch(setCompany(companyObj)),
        setCredentials: (credentialsObj) => dispatch(setCredentials(credentialsObj)),
        setUser: (userObj) => dispatch(setUser(userObj)),
        uploadProfileImage: (objectName) => dispatch(uploadProfileImage(objectName))
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(Account);



// WEBPACK FOOTER //
// ./src/containers/Accounts/Edit/index.js